export default __webpack_public_path__ + "static/media/pic2.87d6b618.jpg";